import React from 'react';
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="row">
          <div className="col-lg-4 mb-4">
            <h5 className="footer-title">BARQ ALWUSOOL</h5>
            <p className="footer-text">
              Safe • Reliable • Comfortable<br/>
              Passenger Transport Across the UAE
            </p>
          </div>
          <div className="col-lg-4 mb-4">
            <h5 className="footer-title">Quick Links</h5>
            <ul className="footer-links">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/services">Services</Link></li>
              <li><Link to="/fleet">Fleet</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>
          <div className="col-lg-4 mb-4">
            <h5 className="footer-title">Service Areas</h5>
            <p className="footer-text">
              Dubai • Abu Dhabi • Sharjah • Ajman<br/>
              Fujairah • Ras Al Khaimah • Umm Al Quwain
            </p>
          </div>
        </div>
        <div className="footer-bottom">
          <p>© 2024 BARQ ALWUSOOL BUSES RENTAL LLC — All Rights Reserved.</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;